<template>
	<div>
		<router-view
			id="new-location-left"
			class="full-height left primary-bg p-l p-r"
			v-if="is_add_new"
		></router-view>
		<div
			v-else
			id="new-location-left"
			class="left full-height primary-bg p-l p-r relative"
		>
			<ImportNewLocs />
		</div>
		<NewLocationMap id="new-location-right" class="full-height right" />
		<div class="clear"></div>
	</div>
</template>

<script>
import NewLocationMap from "@/components/new-location/NewLocationMap";
import ImportNewLocs from "@/components/new-location/ImportNewLocs";

export default {
	name: "Home",
	components: {
		NewLocationMap,
		ImportNewLocs
	},
	computed: {
		is_add_new: function() {
			if (this.$route.name == "add-new") return true;
			else return false;
		}
	}
};
</script>

<style>
:root {
	--left-panel-width: 400px;
}
#new-location-left {
	width: calc(var(--left-panel-width) - 30px);
}
#new-location-right {
	width: calc(100% - var(--left-panel-width));
}
</style>
